namespace $.$$ {
	$mol_style_define( $shm_hitalama_settings_git, {
		width: $mol_style_unit.rem( 40 ),
	} )
}
